import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'unixTimeSinceNow',
    standalone: false,
})
export class UnixTimeSinceNowPipe implements PipeTransform {
    transform(time: number): string {
        return moment.duration(moment.unix(time).diff(moment())).humanize(true);
    }
}
